// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Button } from '@/components/ui/button';
// import { Card } from '@/components/ui/card';
// import { Input } from '@/components/ui/input';
// import { Label } from '@/components/ui/label';
// import { toast } from 'sonner';
// import { Settings as SettingsIcon, Save } from 'lucide-react';

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// const Settings = () => {
//   const [settings, setSettings] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);

//   useEffect(() => {
//     fetchSettings();
//   }, []);

//   const fetchSettings = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const response = await axios.get(`${API}/settings`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setSettings(response.data);
//     } catch (error) {
//       toast.error('Failed to fetch settings');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSaving(true);

//     try {
//       const token = localStorage.getItem('token');
//       await axios.put(`${API}/settings`, settings, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       toast.success('Settings updated successfully');
//     } catch (error) {
//       toast.error('Failed to update settings');
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="p-8 md:p-12">
//         <div className="text-muted-foreground">Loading...</div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-8 md:p-12" data-testid="settings-page">
//       <h1 className="text-4xl md:text-5xl font-bold mb-12 tracking-tight">Settings</h1>

//       <div className="max-w-3xl">
//         <Card className="p-8 border-border/50">
//           <div className="flex items-center gap-3 mb-8">
//             <div className="bg-primary/10 p-3 rounded-xl">
//               <SettingsIcon className="w-6 h-6 text-primary" />
//             </div>
//             <div>
//               <h2 className="text-2xl font-bold">Invoice Customization</h2>
//               <p className="text-sm text-muted-foreground">Customize your invoice appearance</p>
//             </div>
//           </div>

//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div>
//               <Label htmlFor="color-theme">Invoice Color Theme</Label>
//               <div className="flex items-center gap-4">
//                 <Input
//                   id="color-theme"
//                   type="color"
//                   value={settings.invoice_color_theme}
//                   onChange={(e) => setSettings({ ...settings, invoice_color_theme: e.target.value })}
//                   className="w-24 h-12"
//                   data-testid="color-theme-input"
//                 />
//                 <Input
//                   type="text"
//                   value={settings.invoice_color_theme}
//                   onChange={(e) => setSettings({ ...settings, invoice_color_theme: e.target.value })}
//                   placeholder="#F57927"
//                   className="flex-1"
//                 />
//               </div>
//             </div>

//             <div>
//               <Label htmlFor="logo">Business Logo URL</Label>
//               <Input
//                 id="logo"
//                 type="url"
//                 value={settings.business_logo || ''}
//                 onChange={(e) => setSettings({ ...settings, business_logo: e.target.value })}
//                 placeholder="https://example.com/logo.png"
//                 data-testid="logo-input"
//               />
//             </div>

//             <div>
//               <Label htmlFor="header">Invoice Header Text</Label>
//               <Input
//                 id="header"
//                 value={settings.header_text || ''}
//                 onChange={(e) => setSettings({ ...settings, header_text: e.target.value })}
//                 placeholder="Custom header text..."
//                 data-testid="header-input"
//               />
//             </div>

//             <div>
//               <Label htmlFor="footer">Invoice Footer Text</Label>
//               <Input
//                 id="footer"
//                 value={settings.footer_text || ''}
//                 onChange={(e) => setSettings({ ...settings, footer_text: e.target.value })}
//                 placeholder="Thank you for your business!"
//                 data-testid="footer-input"
//               />
//             </div>

//             <div>
//               <Label htmlFor="signature">Signature Block</Label>
//               <textarea
//                 id="signature"
//                 className="w-full px-3 py-2 border border-input rounded-md bg-white min-h-[100px]"
//                 value={settings.signature || ''}
//                 onChange={(e) => setSettings({ ...settings, signature: e.target.value })}
//                 placeholder="Authorized Signatory"
//                 data-testid="signature-input"
//               />
//             </div>

//             <div className="flex justify-end pt-6 border-t border-border">
//               <Button type="submit" disabled={saving} className="gap-2" data-testid="save-settings-button">
//                 <Save className="w-4 h-4" />
//                 {saving ? 'Saving...' : 'Save Settings'}
//               </Button>
//             </div>
//           </form>
//         </Card>

//         <Card className="p-8 mt-6 border-border/50 bg-primary/5">
//           <h3 className="text-lg font-bold mb-4">Preview</h3>
//           <div className="bg-white p-8 rounded-lg border-2" style={{ borderColor: settings.invoice_color_theme }}>
//             <div className="text-center mb-6">
//               {settings.business_logo && (
//                 <img
//                   src={settings.business_logo}
//                   alt="Logo"
//                   className="h-16 mx-auto mb-4 object-contain"
//                   onError={(e) => (e.target.style.display = 'none')}
//                 />
//               )}
//               {settings.header_text && (
//                 <p className="text-sm text-muted-foreground">{settings.header_text}</p>
//               )}
//             </div>
//             <div
//               className="h-2 rounded mb-6"
//               style={{ backgroundColor: settings.invoice_color_theme }}
//             />
//             <p className="text-center text-sm text-muted-foreground mb-4">Sample Invoice Content</p>
//             {settings.signature && (
//               <div className="mt-6 pt-6 border-t border-border">
//                 <pre className="text-sm whitespace-pre-wrap">{settings.signature}</pre>
//               </div>
//             )}
//             {settings.footer_text && (
//               <div className="mt-6 pt-6 border-t border-border text-center text-xs text-muted-foreground">
//                 {settings.footer_text}
//               </div>
//             )}
//           </div>
//         </Card>
//       </div>
//     </div>
//   );
// };

// export default Settings;
import React, { useState, useEffect } from 'react';
// import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Settings as SettingsIcon, Save } from 'lucide-react';

import { db, auth } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const defaultSettings = {
  invoice_color_theme: '#F57927',
  business_logo: '',
  header_text: '',
  footer_text: '',
  signature: '',
};

const Settings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const user = auth.currentUser;
      if (!user) {
        toast.error('Not logged in');
        setSettings(defaultSettings);
        return;
      }

      const ref = doc(db, 'settings', user.uid);
      const snap = await getDoc(ref);

      if (snap.exists()) {
        const data = snap.data();
        setSettings({
          ...defaultSettings,
          ...data, // ensure all fields exist
        });
      } else {
        // no settings yet: use defaults and create doc
        setSettings(defaultSettings);
        await setDoc(ref, defaultSettings);
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to fetch settings');
      setSettings(defaultSettings);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!settings) return;

    setSaving(true);

    try {
      const user = auth.currentUser;
      if (!user) {
        toast.error('Not logged in');
        setSaving(false);
        return;
      }

      const ref = doc(db, 'settings', user.uid);
      await setDoc(ref, settings, { merge: true });

      toast.success('Settings updated successfully');
    } catch (error) {
      console.error(error);
      toast.error('Failed to update settings');
    } finally {
      setSaving(false);
    }
  };

  if (loading || !settings) {
    return (
      <div className="p-8 md:p-12">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return (
    <div className="p-8 md:p-12" data-testid="settings-page">
      <h1 className="text-4xl md:text-5xl font-bold mb-12 tracking-tight">Settings</h1>

      <div className="max-w-3xl">
        <Card className="p-8 border-border/50">
          <div className="flex items-center gap-3 mb-8">
            <div className="bg-primary/10 p-3 rounded-xl">
              <SettingsIcon className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h2 className="text-2xl font-bold">Invoice Customization</h2>
              <p className="text-sm text-muted-foreground">
                Customize your invoice appearance
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="color-theme">Invoice Color Theme</Label>
              <div className="flex items-center gap-4">
                <Input
                  id="color-theme"
                  type="color"
                  value={settings.invoice_color_theme}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      invoice_color_theme: e.target.value,
                    })
                  }
                  className="w-24 h-12"
                  data-testid="color-theme-input"
                />
                <Input
                  type="text"
                  value={settings.invoice_color_theme}
                  onChange={(e) =>
                    setSettings({
                      ...settings,
                      invoice_color_theme: e.target.value,
                    })
                  }
                  placeholder="#F57927"
                  className="flex-1"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="logo">Business Logo URL</Label>
              <Input
                id="logo"
                type="url"
                value={settings.business_logo || ''}
                onChange={(e) =>
                  setSettings({ ...settings, business_logo: e.target.value })
                }
                placeholder="https://example.com/logo.png"
                data-testid="logo-input"
              />
            </div>

            <div>
              <Label htmlFor="header">Invoice Header Text</Label>
              <Input
                id="header"
                value={settings.header_text || ''}
                onChange={(e) =>
                  setSettings({ ...settings, header_text: e.target.value })
                }
                placeholder="Custom header text..."
                data-testid="header-input"
              />
            </div>

            <div>
              <Label htmlFor="footer">Invoice Footer Text</Label>
              <Input
                id="footer"
                value={settings.footer_text || ''}
                onChange={(e) =>
                  setSettings({ ...settings, footer_text: e.target.value })
                }
                placeholder="Thank you for your business!"
                data-testid="footer-input"
              />
            </div>

            <div>
              <Label htmlFor="signature">Signature Block</Label>
              <textarea
                id="signature"
                className="w-full px-3 py-2 border border-input rounded-md bg-white min-h-[100px]"
                value={settings.signature || ''}
                onChange={(e) =>
                  setSettings({ ...settings, signature: e.target.value })
                }
                placeholder="Authorized Signatory"
                data-testid="signature-input"
              />
            </div>

            <div className="flex justify-end pt-6 border-t border-border">
              <Button
                type="submit"
                disabled={saving}
                className="gap-2"
                data-testid="save-settings-button"
              >
                <Save className="w-4 h-4" />
                {saving ? 'Saving...' : 'Save Settings'}
              </Button>
            </div>
          </form>
        </Card>

        <Card className="p-8 mt-6 border-border/50 bg-primary/5">
          <h3 className="text-lg font-bold mb-4">Preview</h3>
          <div
            className="bg-white p-8 rounded-lg border-2"
            style={{ borderColor: settings.invoice_color_theme }}
          >
            <div className="text-center mb-6">
              {settings.business_logo && (
                <img
                  src={settings.business_logo}
                  alt="Logo"
                  className="h-16 mx-auto mb-4 object-contain"
                  onError={(e) => (e.target.style.display = 'none')}
                />
              )}
              {settings.header_text && (
                <p className="text-sm text-muted-foreground">
                  {settings.header_text}
                </p>
              )}
            </div>
            <div
              className="h-2 rounded mb-6"
              style={{ backgroundColor: settings.invoice_color_theme }}
            />
            <p className="text-center text-sm text-muted-foreground mb-4">
              Sample Invoice Content
            </p>
            {settings.signature && (
              <div className="mt-6 pt-6 border-t border-border">
                <pre className="text-sm whitespace-pre-wrap">
                  {settings.signature}
                </pre>
              </div>
            )}
            {settings.footer_text && (
              <div className="mt-6 pt-6 border-t border-border text-center text-xs text-muted-foreground">
                {settings.footer_text}
              </div>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Settings;
